import React from 'react'
import { useHistory } from 'react-router-dom'

const QuizNavigation = ({ dispatch, ...props }) => {
	const history = useHistory()

	const handleNext = (e) => {
		e.preventDefault()

		if (props.index == props?.questions.length - 1) {
			return
		}
		dispatch(props.onClick(props.index + 1))
		history.push(`${props.match.path}?index=${props.index + 1}`)
	}

	const handlePrev = (e) => {
		e.preventDefault()
		if (props.index == 0) {
			return
		}
		dispatch(props.onClick(props.index - 1))
		history.push(`${props.match.path}?index=${props.index - 1}`)
	}

	return (
		<div className='col px-0'>
			<div className='quiz-row-wrapper'>
				{(() => {
					const current = props.index
					var from = 0,
						to = 0,
						reduce = 0,
						len = props?.questions?.length
					const range = window.innerWidth < 500 ? 4 : 4
					const currentRange = window.innerWidth < 500 ? 2 : 2

					if (len > 9) {
						from = current - currentRange >= 0 ? current - currentRange : 0
						reduce = len - current - 1

						if (reduce < 4) {
							from = from - (currentRange - reduce)
						}
					}
					return (
						<div>
							<span className='question-title mb-1'>
								<p>
									{`Question ${current + 1} of ${props?.questions?.length}`}
								</p>
							</span>
							<nav>
								<ul class='pagination px-0 custom-pagination'>
									<li class='page-item'>
										<a //eslint-disable-line
											class='page-link'
											aria-label='Previous'
											onClick={(e) => handlePrev(e)}
										>
											<span aria-hidden='true' className=''>
												&laquo;
											</span>
											<span class='sr-only'>Previous</span>
										</a>
									</li>
									{props?.questions?.map((item, index) => {
										if (len < 10 || (index >= from && to <= range)) {
											to++

											const cn =
												current === index
													? 'bg-success text-white'
													: item.type === 4 ||
														(item.options &&
															item.options.filter((item) => item.selected)
																.length)
														? 'bg-info text-white'
														: ''

											return (
												<li className='page-item'>
													<a //eslint-disable-line
														className={'page-link ' + cn}
														key={index}
														onClick={() => {
															dispatch(props.onClick(index))
															history.push(`${props.match.path}?index=${index}`)
														}}
													>
														{index + 1}
													</a>
												</li>
											)
										}
									})}
									<li class='page-item'>
										<a //eslint-disable-line
											class='page-link'
											onClick={(e) => handleNext(e)}
											aria-label='Next'
										>
											<span aria-hidden='true' className='pb-0'>
												&raquo;
											</span>
											<span class='sr-only'>Next</span>
										</a>
									</li>
								</ul>
							</nav>
						</div>
					)
				})()}
			</div>
		</div>
	)
}

export default QuizNavigation
